import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import styled from "styled-components";
import SecondaryButton from "../components/ui-library/Buttons/SecondaryButton/SecondaryButton";
import PageTitle from "../components/ui-library/HeaderTitles/PageTitle";
import { studiesIds } from "../modules/constants";

const Studies = (props) => {
  const { studies } = props;
  return (
    <div>
      <PageTitle title="Studies List" roleName={"role"} id={"username"} />
      <StudiesList studies={studies} />
    </div>
  );
};

const StyledStudyList = styled.div`
  display: flex;
  justify-content: space-between;
`;
const StudiesList = ({ studies }) => {
  return (
    <StyledStudyList>
      {studies?.map((study, id) => {
        return <StudyCard key={`studycard_${id}`} {...study} />;
      })}
    </StyledStudyList>
  );
};

const StyledStudyCard = styled.div`
  padding: 20px;
`;
const StudyCard = ({ studyid, name, validFrom }) => {
  const studyEnum = Object.keys(studiesIds).find(
    (key) => studiesIds[key].toLowerCase() === studyid.toLowerCase()
  );

  return (
    <StyledStudyCard>
      <SecondaryButton>
        <Link to={`/study/${studyEnum}`}>{name}</Link>
      </SecondaryButton>
    </StyledStudyCard>
  );
};

const mapStateToProps = (state) => {
  const {
    loginReducer: { studies },
  } = state;
  return { studies: studies };
};

export default connect(mapStateToProps, {})(Studies);
